"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var creator_ui_1 = require("@chameleoncreator/creator-ui");
var useSidebar_1 = require("../hooks/useSidebar");
var topics_1 = require("./topics");
var block_1 = require("./block");
exports.Sidebar = function (props) {
    var sidebarlist = react_1.useContext(useSidebar_1.EditContext).sidebarlist;
    var editor;
    if (sidebarlist.length === 0) {
        editor = react_1.default.createElement(topics_1.Topics, null);
    }
    else {
        var o = sidebarlist[sidebarlist.length - 1];
        editor = react_1.default.createElement(block_1.Block, { data: o });
    }
    return react_1.default.createElement(creator_ui_1.Box, null, editor);
};
